import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

// NOTE: This probably can be done a better way, and will need to be in the future if
// we are going to let users import multiple calendars.
// Right now, if you want to add another key/checkbox style, please change it in the local styles.css file.
const CalendarCheckbox = ({ name = '', display, onClick, checked }) => (
  <div>
    <div className="ui checkbox">
      <input
        onChange={() => onClick(name)}
        id={name}
        styleName={`checkbox ${name}`}
        name={name}
        type="checkbox"
        checked={checked}
      />
      <label htmlFor={name} styleName={`checkbox-label ${name}`}>
        {display}
      </label>
    </div>
  </div>
);

CalendarCheckbox.propTypes = {
  name: PropTypes.string,
  display: PropTypes.string,
  onClick: PropTypes.func,
  checked: PropTypes.bool,
};

export default CalendarCheckbox;
